import { render, staticRenderFns } from "./ComboBoxArea.vue?vue&type=template&id=0584ee40&"
import script from "./ComboBoxArea.vue?vue&type=script&lang=ts&"
export * from "./ComboBoxArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports